import { gameQueryOptions } from '@/queries/games/games.queries';
import { PUBLIC_QUERY_STALE_TIME } from '@/queries/queryOptions.helpers';

export const FILTERED_GAME_LIST_DESKTOP_PAGE_SIZE = 30;

type FilterByCategory = { categoryId: string; providerId?: never };
type FilterByProvider = { providerId: string; categoryId?: never };

type FilteredGameListBaseQueryParams = {
  page: number;
  search: string;
  limit: number;
};

type FilteredGameListQueryParams = FilteredGameListBaseQueryParams & (FilterByCategory | FilterByProvider);
type FilteredGameListPrefetchQueryParams = Omit<FilteredGameListBaseQueryParams, 'limit'> & (FilterByCategory | FilterByProvider);

export const filteredGameListQueryOptions = ({
  page,
  search,
  limit,
  providerId,
  categoryId,
}: FilteredGameListQueryParams) =>
  gameQueryOptions.list({
    params: {
      page,
      limit,
      filters: {
        ...(search && { name: search }),
        ...(providerId ? { providerIds: [providerId] } : { categoryId }),
      },
    },
    options: {
      staleTime: PUBLIC_QUERY_STALE_TIME,
    },
  });

export const filteredGameListPrefetchQueryOptions = (
  params: FilteredGameListPrefetchQueryParams,
) => {
  if (params.providerId) {
    return filteredGameListQueryOptions({
      page: params.page,
      search: params.search,
      limit: FILTERED_GAME_LIST_DESKTOP_PAGE_SIZE,
      providerId: params.providerId,
    });
  }

  return filteredGameListQueryOptions({
    page: params.page,
    search: params.search,
    limit: FILTERED_GAME_LIST_DESKTOP_PAGE_SIZE,
    categoryId: params.categoryId!,
  });
};
